export default "__VITE_ASSET__BQWQIkF5__"